import styled from 'styled-components';
import { Badge } from '@gv/triage-components';

export const StatusBadge = styled(Badge)`
  padding: ${({ theme }) =>
    theme.responsive.isMobile ? '4px 8px' : '4px 24px 4px 16px'};
`;
